import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
// import en_US from "antd/es/locale-provider/en_US";
// import zh_CN from "antd/es/locale-provider/zh_CN";
import zh_CN from 'antd/es/locale/zh_CN';
import en_US from 'antd/es/locale/en_US';
import myLoadable from "./myLoadable";
// 多语言
import intl from "react-intl-universal";
// 登录页
import Authrization from './authrization/Authrization';

import "./App.css";
import "./App.less";


// app locale data
const locales = {
  "en-US": require("./locales/en-US.json"),
  "zh-CN": require("./locales/zh-CN.json")
};

const layoutYS = myLoadable({
  loader: () => import("./layoutYS/LayoutYS")
});

const asynDownLoad = myLoadable({
  loader: () => import("./downLoadPage/DownLoadPage")
});
const asynAppDownLoad = myLoadable({
  loader: () => import("./appDownLoad/DownLoadPage")
});
const asynaAuth = myLoadable({
  loader: () => import("./openauth/Index")
});

// const asyncAuthrization = myLoadable({
//   loader: () => import("./authrization/Authrization")
// });

function App(props){
  const [initDone, setInitDone] = useState(false);
  const [antdLocale, setAntdLocale] = useState(zh_CN);
  useEffect(() => {
    let currentLocale = intl.determineLocale({
      urlLocaleKey: 'lang',
      localStorageLocaleKey: 'lang'
    });
    console.log(`currentLocale => ${currentLocale}`);
    // 默认从浏览器中判断是否为中文，否则为英文
    if (!currentLocale) {
      // currentLocale = 'zh-CN';
      const navLan = (navigator.language || navigator.browserLanguage).toLowerCase();
      currentLocale = ["zh-cn", "zh-tw", "zh-hk", "zh-mo", "zh-hant", "zh-hans"].indexOf(navLan) !== -1 ? "zh-CN" : "en-US";
    }
    if(currentLocale === 'en-US'){
      setAntdLocale(en_US);
    }else{
      setAntdLocale(zh_CN);
    }
    intl
      .init({
        currentLocale,
        locales
      })
      .then(() => {
        setInitDone(true)
      });
  })
  return (
    initDone && (
      <div className="openweb">
        <div className="app-router-container">
        <ConfigProvider locale={antdLocale}>
          <Router>
            <Route path="/" component={Authrization} exact />
            <Route path="/authrization" component={Authrization} />
            <Route path="/home" component={layoutYS} />
            <Route path="/admin" component={layoutYS} />
            <Route path="/download" component={asynDownLoad} exact />
            <Route path="/download/oemapp" component={asynAppDownLoad} />
            <Route path="/oauth" component={asynaAuth} />
          </Router>
        </ConfigProvider>
        </div>
      </div>
    )
  );

}

export default App;
